import React from 'react';

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { createAssistantTag } from 'api/assistants';
import { getTags } from 'api/tags';
import { useParams } from 'react-router-dom';
import SelectInput from 'components/Form/SelectInput';
import Button from 'components/Button';
import Popup from 'components/Popup';

export default function AssistantAddTagPopup({
    visible,
    setVisible,
    present = [],
}) {

    const { assistantId } = useParams();
    const cache = useQueryClient();

    const { mutate: update } = useMutation({
        mutationKey: ['updateOffice'],
        mutationFn: createAssistantTag,
        onSuccess: () => {
            cache.invalidateQueries(['assistants', assistantId]);
            return setVisible(false);
        },
        onError: (error) => {
            console.error("Error updating assistant-tag:", error);
        }
    });

    const { data: elements } = useQuery({
        queryKey: ['tags'],
        queryFn: async () => await getTags({}),
    });

    const selectOptions = elements?.map(element => {
        return {
            value: element._id,
            label: element.name
        }
    });

    function onSubmitHandler(e) {
        e.preventDefault();
        return update({
            id: assistantId,
            data: {
                tag: e.target.tag.value
            }
        });
    }

    return (
        <Popup
            visible={visible}
            setVisible={setVisible}
        >
            <form onSubmit={onSubmitHandler}>
                {selectOptions &&
                    <SelectInput
                        label="Seleziona tag"
                        name="tag"
                        options={selectOptions?.filter(element => !present.includes(element.value))}
                        required
                    />
                }

                <div className='flex justify-between gap-4 mt-6'>
                    <div onClick={() => setVisible(false)} className='hover:bg-verylight cursor-pointer px-4 py-3 text-sm rounded-sm'>
                        Annulla
                    </div>
                    <Button submit>Conferma</Button>
                </div>
            </form>
        </Popup>
    )
}
